<template>
  <GraphCard
    :title="settings?.title[locale] ?? ''"
    :state="state"
    :hasError="hasError"
    :filterMessage="filterMessage"
    :additionalInfo="settings?.info?.[locale]"
  >
    <D3Heatmap
      :data="data!"
      :x-access-key="accessKey"
      :color-min="settings?.colorMin ?? '#E6F7FF'"
      :color-max="settings?.colorMax ?? '#40A9FF'"
    />
  </GraphCard>
</template>
<script lang="ts" setup>
import D3Heatmap from './D3Heatmap.vue'
import GraphCard from './GraphCard.vue'
import { computed } from 'vue'
import {
  HeatmapResponse,
  HeatmapSettings,
  HeatmapValue
} from '@/api-client/models/utilization/Contracts'
import { useI18n } from 'vue-i18n'
import { CardState } from '@/components/types'

type Props = {
  data?: HeatmapResponse
  state: CardState
  hasError?: Error
  settings?: HeatmapSettings
  accessKey: keyof HeatmapValue
}
const props = defineProps<Props>()

const filterMessage = computed(() => {
  if (!props.data) return t('general__data__data-missing')
  return t('general__text__filter-to-show-data')
})
const { t, locale } = useI18n()
</script>
